import { render } from 'react-dom';
import AbylaiGSGraph from './abylaiGSGraph';

const rootElement = document.querySelector('#root');
if (rootElement) {
  render(
    <AbylaiGSGraph/>,
    rootElement);
}
